import { tzAxios } from 'api/axios';
import { AlipaySingleOrderCallback, AlipaySingleOrderRequest } from 'api/requestTypes';
import { SingleOrderResponse } from 'api/responseTypes';

export const sendOrderSuperQi = async (data: SingleOrderResponse) =>
  (await tzAxios.post<AlipaySingleOrderRequest>(`/ticket-zone/checkout`, data)).data;

export const sendOrderNumberSuperQi = async (data: AlipaySingleOrderCallback) =>
  (await tzAxios.post(`/ticket-zone/ticket-orders/purchase/callback/miniProgram`, data)).data;
